import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useState } from "react";
import { useEffect } from "react";
import InteraktScript from "../../common/InteraktScript";
function Contact() {
  const [nm, setNm] = useState("");
  const [phno, setPhno] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [msg, setMsg] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [userid, setUserid] = useState(0);
  useEffect(() => {
    const userIdValue = localStorage.getItem("userId");
    setUserid(userIdValue);
  }, [userid]);
  const handleSubmit = (e) => {
    e.preventDefault();
    let flag = 0;

    // Basic email validation
    if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)) {
      alert("Please enter a valid email address.");
      flag = 1;
    }

    // Basic phone number validation (assuming a 10-digit number)
    if (!/^\d{10}$/.test(contact)) {
      alert("Please enter a valid 10-digit phone number.");
      flag = 1;
    }

    if (flag === 0) {
      sentMail();
    }
  };

  const sentMail = () => {
    const mailtoLink = `mailto:info@myprega.com?subject=About&body=I'm contacting you because ${encodeURIComponent(
      nm
    )}Let's start by getting to know you better. Hi, I'm ${encodeURIComponent(
      phno
    )}You can reply to me at ${encodeURIComponent(
      email
    )}You can reply to me when I'm offline ${encodeURIComponent(
      contact
    )}Story ${encodeURIComponent(msg)}`;

    window.location.href = mailtoLink;
  };

  const handleContactChange = (e) => {
    const inputValue = e.target.value;

    // Basic client-side validation for a 10-digit phone number

    setContact(inputValue);
  };

  return (
    <div className="new-home">
      <Header userid={userid} />
      <div className="contact-page-section">
        <div
          className="contact-page-shell"
          style={{
            backgroundImage: `linear-gradient(180deg, rgba(255, 248, 243, 0.03) 0%, rgba(255, 255, 255, 0.82) 85%), url(${process.env.PUBLIC_URL}/contactB.png)`,
          }}
        >
          <div className="contact-page-inner container">
            <div className="contact-page-hero">
              <h1 className="contact-page-title">
                Let&apos;s Talk But <span>You Firsts</span>
              </h1>
              <p className="contact-page-subtitle">
                We&apos;ve got all kinds of ways to help you find out,
                <br />
                Here&apos;s how you can contact us for customer service.
              </p>
            </div>
          </div>
        </div>

        <div className="contact-page-content">
          <div className="contact-page-inner container">
            <div className="contact-info-row">
              <div className="contact-info-card">
                <span className="contact-info-label">Email</span>
                <p>info@myprega.com</p>
              </div>
              <div className="contact-info-card">
                <span className="contact-info-label">Phone number</span>
                <p>+91 97023246288</p>
                <small>9 am to 7 pm, All days</small>
              </div>
            </div>

            <div className="contact-form-wrap">
              <img
                src="/contactL.png"
                alt=""
                className="contact-side-art contact-side-art-left"
              />
              <img
                src="/contactR.png"
                alt=""
                className="contact-side-art contact-side-art-right"
              />

              <div className="form_container contact-form-card">
                <h2 className="contact-form-title">
                  Get in <span>touch</span>
                </h2>
                <form action="" className="contact-form-grid">
                  <div className="contact-field">
                    <label>I&apos;m contacting you because</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nm"
                      placeholder="Write here your problem"
                      value={nm}
                      onChange={(e) => {
                        const inputval = e.target.value;
                        if (/^[A-Za-z]+$/.test(inputval) || inputval === "") {
                          setNm(inputval);
                        } else {
                          alert("Please enter only alphabetic characters.");
                        }
                      }}
                    />
                  </div>
                  <div className="contact-field">
                    <label>Let&apos;s start by getting know better. Hi I&apos;m</label>
                    <input
                      type="text"
                      className="form-control"
                      id="phno"
                      value={phno}
                      onChange={(e) => {
                        const inputval = e.target.value;
                        if (/^[A-Za-z]+$/.test(inputval) || inputval === "") {
                          setPhno(inputval);
                        } else {
                          alert("Please enter only alphabetic characters.");
                        }
                      }}
                      placeholder="Type your name"
                    />
                  </div>
                  <div className="contact-field">
                    <label>You can reply to me at</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Type your email"
                      value={email}
                      onChange={(e) => {
                        const inputVal = e.target.value;
                        setEmail(inputVal);
                      }}
                    />
                  </div>
                  <div className="contact-field">
                    <label>You can reply to me when I&apos;m offline</label>
                    <input
                      type="number"
                      className="form-control"
                      id="contact"
                      value={contact}
                      onChange={handleContactChange}
                      placeholder="Type your contact number"
                    />
                  </div>
                  <div className="contact-field contact-field-full">
                    <label>As long as you promise not to</label>
                    <select className="dropd">
                      <option value="op1">Reply like a generic robot</option>
                      <option value="op2">All of the above, LOL</option>
                    </select>
                  </div>
                  <div className="contact-field contact-field-full">
                    <label>
                      Questions, sad or happy stories, complaints or even just a
                      quick hello, send us a note. We&apos;ll read every word.
                    </label>
                    <textarea
                      id="msg"
                      className="form-control contact-message-box"
                      placeholder="Write here your problem"
                      value={msg}
                      onChange={(e) => setMsg(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="btn_box contact-submit-wrap">
                    <button
                      className="btn contact-submit-btn"
                      id="sendbtn"
                      // onClick={handleSubmit}
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <InteraktScript />
    </div>
  );
}

export default Contact;
